import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import CommonSignUpModal from '../../components/Header/CommonSignUpModal';
import LoginModal1 from '../../components/Header/LoginModal1';
import styled from 'styled-components';

const PageWrapper = styled.div`
  //padding: 40px 0;
  display: flex;
  justify-content: center;
  width: 100%;
  
  & > div > div {
    max-height: none !important;
    height: auto !important;
  }
`;

const SignupPage = () => {
  const [isSignUpModal, setSignUpModal] = useState(true);
  const history = useHistory();

  useEffect(() => {
    document.body.style.overflow = 'auto';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const toggleSignUp = () => {
    setSignUpModal(!isSignUpModal);
  };

  return (
    <PageWrapper>
      {isSignUpModal ? (
        <CommonSignUpModal 
          isSignUpModal={isSignUpModal}
          setSignUpModal={setSignUpModal}
          toggleSignUp={toggleSignUp}
        />
      ) : (
        <LoginModal1 
          isSignUpModal={isSignUpModal}
          setLoginToggle={() => history.push('/')}
          loginToggle={true}
          toggleLogin={toggleSignUp}
        />
      )}
    </PageWrapper>
  );
};

export default SignupPage;
